import React, { useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';

const font = "'DM Sans', sans-serif";

/**
 * VideoPlayer — YouTube embed for Tu Radar course videos.
 *
 * Props:
 *   video: { id, title, description, youtube_id, duration, unlock_day }
 *   userId: string (for tracking views)
 *   unlocked: boolean
 *   isMobile: boolean
 */
export default function VideoPlayer({ video, userId, unlocked = false, isMobile = false }) {
  // Track view when video loads
  useEffect(() => {
    if (!video?.youtube_id || !userId || !unlocked) return;
    supabase
      .from('radar_video_views')
      .upsert({
        user_id: userId,
        video_id: video.id,
        watched_at: new Date().toISOString(),
        completed: false,
      }, { onConflict: 'user_id,video_id' })
      .then(({ error }) => {
        if (error) console.error('[VideoPlayer] Track error:', error.message);
      });
  }, [video?.id, userId, unlocked]);

  if (!unlocked) {
    return (
      <div style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        padding: '40px 20px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: 32, margin: '0 0 8px' }}>🔒</p>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', margin: 0, fontFamily: font }}>
          Se desbloquea el día {video?.unlock_day || '?'}
        </p>
      </div>
    );
  }

  if (!video?.youtube_id) {
    return (
      <div style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        padding: '40px 20px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: 32, margin: '0 0 8px' }}>🎬</p>
        <p style={{ fontSize: 14, fontWeight: 500, margin: '0 0 4px', fontFamily: font, color: '#fff' }}>
          {video?.title || 'Video'}
        </p>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', margin: 0, fontFamily: font }}>
          Video próximamente · {video?.duration || ''}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div style={{
        position: 'relative',
        paddingBottom: '56.25%', // 16:9
        height: 0,
        borderRadius: 16,
        overflow: 'hidden',
        background: '#000',
      }}>
        <iframe
          src={`https://www.youtube.com/embed/${video.youtube_id}?rel=0&modestbranding=1&color=white`}
          title={video.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
        />
      </div>
      <div style={{ marginTop: 12 }}>
        <p style={{ fontSize: 16, fontWeight: 500, margin: '0 0 4px', fontFamily: font, color: '#fff' }}>
          {video.title}
        </p>
        {video.description && (
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6, margin: 0, fontFamily: font }}>
            {video.description}
          </p>
        )}
      </div>
    </div>
  );
}
